export default __webpack_public_path__ + "static/media/playImg.aa967896.svg";